import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import useAudit from './useAudit'
import { Reason, LoadState, Pagination } from './parts'
import { catalogIndex, feedbackLanguage, themeColumns, ThemeCell, ThemeTitle, FeedbackAuthor, FeedbackMessage, StarText } from './TournamentFeedback'

// „View audit” of one tournament feedback: every saved version, and the eligibility of the author's general tournament
// review, which the feedback follows (it has none of its own).
export default function FeedbackAuditDetail({ row, onClose, t }) {
  const { i18n } = useTranslation('reviewAudit')
  const [page, setPage] = useState(1)
  const [historyPage, setHistoryPage] = useState(1)
  const state = useAudit(`/admin/review-audit/tournament-feedback/${encodeURIComponent(row.id)}?page=${page}&limit=20&historyPage=${historyPage}&historyLimit=20&language=${feedbackLanguage(i18n.language)}`)
  const { data } = state
  const record = data?.record
  const index = catalogIndex(data?.catalog)
  const columns = data ? themeColumns(index, [record, ...data.versions.results]) : []
  const generalNote = data?.generalReview?.value
  const organizer = [...index.themes.values()].find(theme => theme.type === 'generalNote')
  const organizerReasons = record && !record.organizerReasonsCounted && organizer && record.reasons?.[organizer.code]?.length
  return <Modal isOpen toggle={onClose} size="xl"><ModalHeader toggle={onClose}>{t('audit')}</ModalHeader><ModalBody>
    <LoadState state={state} t={t} />
    {data && <>
      <h5>{t('tournament-feedback')}</h5>
      <p>{t('author')}: <FeedbackAuthor row={record} t={t} /></p>
      <p>{t('eligibility')}: {t(record.eligibility)} {record.reason && <Reason reason={record.reason} t={t} />} <small className="text-muted">({t('feedbackFollowsGeneral')})</small></p>
      {generalNote != null && <p><StarText text={t('feedbackGeneralNow', { rating: generalNote })} t={t} />{organizerReasons ? ' · ' + t('feedbackOrganizerRemoved') : ''}</p>}
      <h5>{t('feedbackVersions')}</h5>
      <div className="table-responsive"><table className="table table-striped" aria-label={t('feedbackVersions')}>
        <thead><tr>
          <th scope="col">{t('revision')}</th>
          {columns.map(theme => <th scope="col" key={theme.code}><ThemeTitle theme={theme} code={theme.code} t={t} /></th>)}
          <th scope="col">{t('feedbackMessage')}</th><th scope="col">{t('date')}</th>
        </tr></thead>
        <tbody>{data.versions.results.map(version => <tr key={version.seq}>
          <td>{version.seq}</td>
          {columns.map(theme => <ThemeCell key={theme.code} theme={theme} answer={version} deleted={record.authorDeleted}
            notCounted={version.seq === record.revision && !record.organizerReasonsCounted} generalNote={record.generalNote} t={t} />)}
          <td className="cp-feedback-message"><FeedbackMessage message={version.message} deleted={record.authorDeleted} t={t} /></td>
          <td>{version.recordedAt ? new Date(version.recordedAt).toLocaleString() : '—'}</td>
        </tr>)}</tbody>
      </table></div>
      <Pagination data={data.versions} onPage={setPage} t={t} />
      <h5 className="mt-4">{t('lifecycle')}</h5><p className="text-muted">{t('feedbackLifecycle')}</p>
      {data.lifecycle.results.length ? <div className="table-responsive"><table className="table"><thead><tr>{['date', 'eligibility', 'reason'].map(key => <th scope="col" key={key}>{t(key)}</th>)}</tr></thead>
        <tbody>{data.lifecycle.results.map((item, position) => <tr key={item._id || `${item.revision}:${position}`}><td>{item.recordedAt ? new Date(item.recordedAt).toLocaleString() : '—'}</td><td>{t(item.state)}</td><td><Reason reason={item.reason} t={t} /></td></tr>)}</tbody>
      </table></div> : <p>{t('noTransitions')}</p>}
      <Pagination data={data.lifecycle} onPage={setHistoryPage} t={t} />
    </>}
  </ModalBody></Modal>
}
